// Authentication and API calls
export const SERVICE_EXECUTE_API = "execute-api"
export const METHOD_GET = "GET"
export const METHOD_POST = "POST"
export const METHOD_PUT = "PUT"
export const PATH_PROD = "/prod"
export const AMAZON_AWS = "amazonaws"

export const API_IAM_ROLE_MAPPING = {
    "https://3ewjdxae17.execute-api.us-west-2.amazonaws.com/prod": "arn:aws:iam::418272775918:role/Authtestrole"
}
export const paymentMethodQuery = "/getDropdownValues?type=PaymentMethod";
export const businessQuery = "/getDropdownValues?type=Business";
export const subBusinessQuery = "/getDropdownValues?type=Sub%20Business";
export const countryQuery = "/getDropdownValues?type=Country";
export const currencyQuery = "/getDropdownValues?type=Currency";
export const operatingUnitQuery = "/getDropdownValues?type=Operating%20Unit";
export const expectedResultQuery = "/getDropdownValues?type=ExpectedResult";
export const projectQuery = "/getProjectValues";
export const getTellerProjects = "?service=Teller";
export const getOfaProjects = "?service=OFA";
export const createTestcase = "/testcases";
export const getTestcase = "/testcases";
export const getTestExecutionTeller = "/testExecution/Teller";
export const initiatePaymentApi = "/initiatePayment";
export const updateCommentApi = "/testExecution/updateComment";

export const tellerPayableLink = "https://teller-webapp-beta.integ.amazon.com/payable/";
export const dollarglassLink = "https://beta.dollarglass.fintech.amazon.dev/#/search/?q=";

